export default __webpack_public_path__ + "static/media/information--end-of-road-works--g1.5b7f3560.png";